module.exports = __webpack_public_path__ + "static/media/caret_up.c78b3fdb.svg";